import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Position, XYPosition } from '../../../../../../../Common/data/position';
import { SizeChanged } from '../../../util/resize.directive';

enum TextPositon {
  TopRight,
  TopLeft,
  BottomRight,
  BottomLeft,
}

@Component({
  selector: 'app-show-all-question',
  templateUrl: './show-all-question.component.html',
  styleUrls: ['show-all-question.component.scss'],
})
export class ShowAllQuestionComponent implements OnChanges {
  @Input()
  questionPosition: Position;
  @Input()
  showCrosswordWidth: number;
  @Input()
  tileSize: number;
  position: XYPosition;

  private size: SizeChanged = { width: 0, height: 0 };

  constructor(private crf: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showCrosswordWidth || changes.tileSize || changes.questionPosition) {
      this.calculatePosition();
    }
  }

  onElementSize(size: SizeChanged) {
    if (this.size.width !== size.width || this.size.height !== size.height) {
      this.size = size;
      this.calculatePosition();
    }
  }
  private calculatePosition() {
    const textPosition = this.getTextPosition();
    const rightX = this.questionPosition.x + this.tileSize + 1;
    const leftX = Math.max(this.questionPosition.x - this.size.width, 0);
    const topY = this.questionPosition.y - this.size.height - 1;
    const bottomY = this.questionPosition.y + this.tileSize + 1;

    if (textPosition == TextPositon.TopRight) {
      this.position = { x: rightX, y: topY };
    } else if (textPosition == TextPositon.TopLeft) {
      this.position = { x: leftX, y: topY };
    } else if (textPosition == TextPositon.BottomRight) {
      this.position = { x: rightX, y: bottomY };
    } else {
      this.position = { x: leftX, y: bottomY };
    }
    this.crf.detectChanges();
  }
  private getTextPosition() {
    const rightQuestionPositionX = this.questionPosition.x + this.tileSize + this.size.width + 1;
    const textWillExceedWitdth = rightQuestionPositionX > this.showCrosswordWidth;
    if (this.questionPosition.y - this.size.height > 0) {
      return textWillExceedWitdth ? TextPositon.TopLeft : TextPositon.TopRight;
    } else {
      return textWillExceedWitdth ? TextPositon.BottomLeft : TextPositon.BottomRight;
    }
  }
}
